import { createSlice } from "@reduxjs/toolkit";

import { system_toast } from "../../service/system";

export const systemSlice = createSlice({
  name: "system",
  initialState: {
    // 後台版型設定
    backLayout: {
      isSideShow: true,
      isSideFixed: true,
    },
    isProgress: false, // 是否顯示loading
    toast: null, // toast 顯示訊息
  },
  reducers: {
    setBackLayout: (state, action) => {
      state.backLayout = {
        ...state.backLayout,
        ...action.payload,
      };
    },
    setProgress: (state, action) => {
      // 控制是否顯示 porgress
      state.isProgress = action.payload;
    },
    setToast: (state, action) => {
      // 控制 toast 顯示的內容
      if (!action.payload) {
        state.toast = null;
        return;
      }

      state.toast = {
        life: system_toast.life,
        ...action.payload,
      };
    },
  },
});

export const { setBackLayout, setProgress, setToast } = systemSlice.actions;

export default systemSlice.reducer;
